const Dimensions = 
{
  //Alturas en porcentaje
  navbar    : 5,
  menu      : 7,
  footer    : 5,
  
  modal01   : 60,
  modal02   : 70,

  //anchos en pixeles
  searchbar : 300
};

export default Dimensions;